export enum ETravelModes {
  DRIVING = 'DRIVING',
  BICYCLING = 'BICYCLING',
  TRANSIT = 'TRANSIT',
  WALKING = 'WALKING'
}
export interface IRouting {
  node: Array<String>
  distance: Number
  distanceDetail: Object
  time: Number
  timeDetail: Object
  vehicleTypes: Array<String>
  vehicleTypesName: Array<String>
  tollStation: Array<{ [key: string]: any }>
  specialNode: Array<String>
  routing: Array<{ [key: string]: any }>
  travelModes: String
  status: Number
}
const initValue = {
  node: [''],
  distance: 0,
  distanceDetail: {
    text: '',
    value: 0
  },
  time: 0,
  timeCenterPoint: '',
  distanceCenterPoint: 0,
  routesCenterPoint: [],
  timeDetail: {
    text: '',
    value: 0
  },
  vehicleTypes: [],
  vehicleTypesName: [],
  tollStation: [
    {
      id: '',
      name: ''
    }
  ],
  specialNode: [],
  routing: [],
  travelModes: ETravelModes.DRIVING,
  status: 0
}
export default {
  initValue
}
